export enum DeputyFullPosition {
  DeputyPosition = 'deputy_position',
  FullPosition = 'full_position',
}
